import { Grid, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import React, { FunctionComponent } from "react";
import {
    AgentCalls,
    CallDurationStats,
    InteractionDateStats,
} from "../../../../../../models/RecommendedSample";
import { durationFormatter } from "../../../../../ManagerInteractions/Util";
import AcxControlledTable from "../../../../../UI/AcxTable/AcxControlledTable";
import { IAcxTableColumn } from "../../../../../UI/AcxTable/AcxTable";
import theme from "Theme/AppTheme";

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: "bold",
}));

const MainContent = styled(Grid)(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginTop: theme.spacing(2),
}));

interface OwnProps {
    agentCalls?: AgentCalls[];
    durationStats?: CallDurationStats;
    dateStats?: InteractionDateStats;
    onClose: () => void;
}

type Props = OwnProps;

const RecommendationStats: FunctionComponent<Props> = (props) => {
    const columnDefs = [
        ["AgentName", "agentName"],
        ["Calls", "callCount"],
    ];

    const columns = columnDefs.map((c) => {
        return {
            headerLabel: c[0],
            dataKey: c[1],
        } as IAcxTableColumn;
    });

    return (
        <div style={{ width: "500px", paddingLeft: theme.spacing(1) }}>
            <Grid container justifyContent={"flex-start"}>
                <Grid
                    item
                    xs={12}
                    container
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <Grid item>
                        <Typography variant={"h5"}>
                            Recommendation Statistics
                        </Typography>
                    </Grid>
                    <Grid item style={{ alignSelf: "flex-start" }}>
                        <IconButton onClick={props.onClose} size="large">
                            <CloseIcon fontSize={"medium"} />
                        </IconButton>
                    </Grid>
                </Grid>

                <MainContent item xs={12} container>
                    <Grid item xs={12} style={{ marginBottom: "8px" }}>
                        <SectionTitle variant={"h3"}>
                            Interaction Date Range
                        </SectionTitle>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            {props.dateStats?.minDate
                                ? moment(props.dateStats?.minDate).format(
                                      "YYYY-MM-DD hh:mm A",
                                  )
                                : ""}{" "}
                            -{" "}
                            {props.dateStats?.maxDate
                                ? moment(props.dateStats?.maxDate).format(
                                      "YYYY-MM-DD hh:mm A",
                                  )
                                : ""}
                        </Typography>
                    </Grid>
                </MainContent>

                <MainContent item xs={12} container>
                    <Grid item xs={12} style={{ marginBottom: "8px" }}>
                        <SectionTitle variant={"h3"}>
                            Call Duration Range
                        </SectionTitle>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            {durationFormatter(
                                props.durationStats?.minDuration,
                            )}{" "}
                            -{" "}
                            {durationFormatter(
                                props.durationStats?.maxDuration,
                            )}
                        </Typography>
                    </Grid>
                </MainContent>

                <MainContent item xs={12}>
                    <div style={{ height: "100%", minHeight: "175px" }}>
                        <AcxControlledTable
                            rowTerm={
                                <SectionTitle variant={"h3"}>
                                    Agent Call Distribution
                                </SectionTitle>
                            }
                            cellDense
                            enableSort
                            columns={columns}
                            rows={props.agentCalls ?? []}
                        />
                    </div>
                </MainContent>
            </Grid>
        </div>
    );
};

export default RecommendationStats;
